<h1>Material UI Component Showcase</h1>

<!-- Typography -->
<section>
  <div class="example-label">Typography</div>
  <div class="example-content">
    <h1>This is an H1</h1>
    <h2>This is an H2</h2>
    <h3>This is an H3</h3>
    <h4>This is an H4</h4>
    <p>This is the default paragraph text</p>
    <span class="mat-caption">This is caption text</span>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Buttons -->
<section>
  <div class="example-label">Basic</div>
  <div class="example-button-row">
    <button mat-button>Basic</button>
    <button mat-button disabled>Disabled</button>
    <a mat-button href="https://www.google.com/" target="_blank">Link</a>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">Raised</div>
  <div class="example-button-row">
    <button mat-raised-button>Basic</button>
    <button mat-raised-button disabled>Disabled</button>
    <a mat-raised-button href="https://www.google.com/" target="_blank">Link</a>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">Stroked</div>
  <div class="example-button-row">
    <button mat-stroked-button>Basic</button>
    <button mat-stroked-button disabled>Disabled</button>
    <a mat-stroked-button href="https://www.google.com/" target="_blank">Link</a>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">Flat</div>
  <div class="example-button-row">
    <button mat-flat-button>Basic</button>
    <button mat-flat-button disabled>Disabled</button>
    <a mat-flat-button href="https://www.google.com/" target="_blank">Link</a>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">Icon</div>
  <div class="example-button-row">
    <div class="example-flex-container">
      <button mat-icon-button aria-label="Example icon button with a vertical three dot icon">
        <mat-icon>more_vert</mat-icon>
      </button>
      <button mat-icon-button disabled aria-label="Example icon button with a open in new tab icon">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </div>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">FAB</div>
  <div class="example-button-row">
    <div class="example-flex-container">
      <div class="example-button-container">
        <button mat-fab aria-label="Example icon button with a delete icon">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
      <div class="example-button-container">
        <button mat-fab disabled aria-label="Example icon button with a heart icon">
          <mat-icon>favorite</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<mat-divider></mat-divider>
<section>
  <div class="example-label">Mini FAB</div>
  <div class="example-button-row">
    <div class="example-flex-container">
      <div class="example-button-container">
        <button mat-mini-fab aria-label="Example icon button with a menu icon">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
      <div class="example-button-container">
        <button mat-mini-fab disabled aria-label="Example icon button with a home icon">
          <mat-icon>home</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="example-label">Extended Fab</div>
  <div class="example-button-row">
    <div class="example-flex-container">
      <div class="example-button-container">
        <button mat-fab extended>
          <mat-icon>favorite</mat-icon>
          Basic
        </button>
      </div>
      <div class="example-button-container">
        <button mat-fab extended disabled>
          <mat-icon>favorite</mat-icon>
          Disabled
        </button>
      </div>
      <div class="example-button-container">
        <a mat-fab extended routerLink=".">
          <mat-icon>favorite</mat-icon>
          Link
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Form Fields -->
<section>
  <div class="example-label">Form Fields</div>
  <div class="example-content">
    <mat-form-field appearance="outline" color="primary">
      <mat-label>Primary Outline</mat-label>
      <input matInput placeholder="Enter text" />
      <mat-icon matSuffix>sentiment_very_satisfied</mat-icon>
      <mat-hint>Helper text</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="fill" color="accent">
      <mat-label>Accent Fill</mat-label>
      <input matInput placeholder="Enter text" />
      <mat-hint>Helper text</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Standard</mat-label>
      <input matInput placeholder="Enter text" disabled />
      <mat-hint>Disabled input</mat-hint>
    </mat-form-field>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Select -->
<section>
  <div class="example-label">Select</div>
  <div class="example-content">
    <mat-form-field appearance="fill">
      <mat-label>Choose an option</mat-label>
      <mat-select>
        <mat-option value="option1">Option 1</mat-option>
        <mat-option value="option2">Option 2</mat-option>
        <mat-option value="option3">Option 3</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" color="accent">
      <mat-label>Multiple select</mat-label>
      <mat-select multiple>
        <mat-option value="option1">Option 1</mat-option>
        <mat-option value="option2">Option 2</mat-option>
        <mat-option value="option3">Option 3</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Checkbox and Radio -->
<section>
  <div class="example-label">Selection Controls</div>
  <div class="example-content">
    <div class="controls-container">
      <mat-checkbox color="primary">Primary checkbox</mat-checkbox>
      <mat-checkbox color="accent">Accent checkbox</mat-checkbox>
      <mat-checkbox color="warn">Warn checkbox</mat-checkbox>
      <mat-checkbox disabled>Disabled checkbox</mat-checkbox>
    </div>

    <div class="controls-container">
      <mat-radio-group aria-label="Select an option">
        <mat-radio-button value="1" color="primary">Primary radio</mat-radio-button>
        <mat-radio-button value="2" color="accent">Accent radio</mat-radio-button>
        <mat-radio-button value="3" color="warn">Warn radio</mat-radio-button>
        <mat-radio-button value="4" disabled>Disabled radio</mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="controls-container">
      <mat-slide-toggle color="primary">Primary toggle</mat-slide-toggle>
      <mat-slide-toggle color="accent">Accent toggle</mat-slide-toggle>
      <mat-slide-toggle color="warn">Warn toggle</mat-slide-toggle>
      <mat-slide-toggle disabled>Disabled toggle</mat-slide-toggle>
    </div>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Card -->
<section>
  <div class="example-label">Cards</div>
  <div class="example-content cards-container">
    <mat-card class="example-card">
      <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title>Basic Card</mat-card-title>
        <mat-card-subtitle>Card Subtitle</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <p>
          This is a basic card with some content. The card demonstrates the Material Design card component from Angular
          Material.
        </p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button color="primary">LIKE</button>
        <button mat-button color="accent">SHARE</button>
      </mat-card-actions>
    </mat-card>

    <mat-card class="example-card">
      <mat-card-header>
        <mat-card-title>Actions Card</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>This card demonstrates various actions and buttons.</p>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-raised-button color="primary">SUBMIT</button>
        <button mat-stroked-button color="accent">CANCEL</button>
      </mat-card-actions>
    </mat-card>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Progress Indicators -->
<section>
  <div class="example-label">Progress</div>
  <div class="example-content">
    <div class="progress-container">
      <p>Determinate</p>
      <mat-progress-bar mode="determinate" value="40" color="primary"></mat-progress-bar>
      <p>Indeterminate</p>
      <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
      <p>Buffer</p>
      <mat-progress-bar mode="buffer" value="60" color="warn"></mat-progress-bar>
      <p>query</p>
      <mat-progress-bar mode="query"></mat-progress-bar>
    </div>

    <div class="spinner-container">
      <p>Spinner</p>
      <mat-spinner diameter="40" color="primary"></mat-spinner>
    </div>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Tabs -->
<section>
  <div class="example-label">Tabs</div>
  <div class="example-content">
    <mat-tab-group mat-align-tabs="start">
      <mat-tab label="First Tab">
        <div class="tab-content">Content for first tab</div>
      </mat-tab>
      <mat-tab label="Second Tab">
        <div class="tab-content">Content for second tab</div>
      </mat-tab>
      <mat-tab label="Third Tab">
        <div class="tab-content">Content for third tab</div>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Expansion Panel -->
<section>
  <div class="example-label">Expansion Panel</div>
  <div class="example-content">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>Personal Information</mat-panel-title>
          <mat-panel-description>User details</mat-panel-description>
        </mat-expansion-panel-header>
        <p>This is the primary content of the panel.</p>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>Preferences</mat-panel-title>
          <mat-panel-description>User preferences</mat-panel-description>
        </mat-expansion-panel-header>
        <p>This panel is expanded by default.</p>
      </mat-expansion-panel>

      <mat-expansion-panel disabled>
        <mat-expansion-panel-header>
          <mat-panel-title>Disabled Panel</mat-panel-title>
        </mat-expansion-panel-header>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Chips -->
<section>
  <div class="example-label">Chips</div>
  <div class="example-content">
    <mat-chip-set>
      <mat-chip color="primary" selected>Primary</mat-chip>
      <mat-chip color="accent" selected>Accent</mat-chip>
      <mat-chip color="warn" selected>Warn</mat-chip>
      <mat-chip disabled>Disabled</mat-chip>
      <mat-chip>
        <mat-icon matChipAvatar>face</mat-icon>
        With Icon
      </mat-chip>
      <mat-chip color="primary" selected>
        <span>Removable</span>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>
  </div>
</section>
<mat-divider></mat-divider>

<!-- Badge and Icons -->
<section>
  <div class="example-label">Badge</div>
  <div class="example-content badge-container">
    <div>
      <span matBadge="4" matBadgeOverlap="false">Text with a badge</span>
    </div>
    <div>
      <span matBadge="8" matBadgeColor="accent">Accent badge</span>
    </div>
    <div>
      <span matBadge="15" matBadgeColor="warn">Warn badge</span>
    </div>
    <div>
      <button mat-raised-button matBadge="7" matBadgePosition="before" matBadgeColor="accent">Action</button>
    </div>
    <div>
      <mat-icon matBadge="22" matBadgeColor="primary">home</mat-icon>
    </div>
  </div>
</section>
